export default __webpack_public_path__ + "static/media/image3.78e38687.png";